import { Suspense, lazy, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import ScrollToTop from "./components/scroll-to-top";
import { OpenCloseContactContext } from "./contexts/contact";
import { LoaderContext } from "./contexts/loader";
import { WEB_ROUTES } from "./routes/web-routes";
import CookieConsent from "./components/CookieConsent";
import ReactGA from "react-ga4";
import { setupAxiosCache } from "./lib/axiosCache";

ReactGA.initialize("G-9NL84H7KHH");
setupAxiosCache();

const Home = lazy(() => import("./pages/home"));
const About = lazy(() => import("./pages/about"));
const Contact = lazy(() => import("./pages/contact"));
const BusinessIntegrity = lazy(() => import("./pages/sustainability"));
const Project = lazy(() => import("./pages/project"));
const Leadership = lazy(() => import("./pages/leadership"));
const LeadershipSingle = lazy(() => import("./pages/leadership-single"));
const News = lazy(() => import("./pages/news"));
const FeaturedIn = lazy(() => import("./pages/featured-in"));
const NewsSingle = lazy(() => import("./pages/news-single"));
const Newsletter = lazy(() => import("./pages/newsletter"));
const Careers = lazy(() => import("./pages/careers"));
const Page = lazy(() => import("./pages/page"));
const Gallery = lazy(() => import("./pages/Gallery"));
const GallerySingle = lazy(() => import("./pages/gallery-single"));

function App() {
  const [openCloseContact, setOpenCloseContact] = useState(false);
  const [loading, setLoading] = useState(false);

  return (
    <LoaderContext.Provider value={{ loading, setLoading }}>
      <OpenCloseContactContext.Provider
        value={{ openCloseContact, setOpenCloseContact }}
      >
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<div className="min-h-screen" />}>
            <Routes>
              {/* PUBLIC ROUTES */}
              <Route index exact path={WEB_ROUTES.HOME} element={<Home />} />
              <Route path={WEB_ROUTES.ABOUT} element={<About />} />
              <Route path={WEB_ROUTES.LEADERSHIP} element={<Leadership />} />
              <Route
                path={WEB_ROUTES.LEADERSHIP + `/:leader`}
                element={<LeadershipSingle />}
              />
              <Route path={WEB_ROUTES.PROJECT} element={<Project />} />
              <Route path={WEB_ROUTES.IMPACT} element={<BusinessIntegrity />} />
              <Route path={WEB_ROUTES.NEWS} element={<News />} />
              <Route path={WEB_ROUTES.NEWS + `/:news`} element={<NewsSingle />} />
              <Route path={WEB_ROUTES.FEATURED_IN} element={<FeaturedIn />} />
              <Route path={WEB_ROUTES.CONTACT} element={<Contact />} />
              <Route path={WEB_ROUTES.NEWSLETTER} element={<Newsletter />} />
              <Route path={WEB_ROUTES.CAREERS} element={<Careers />} />
              <Route path={WEB_ROUTES.GALLERY} element={<Gallery />} />
              <Route
                path={WEB_ROUTES.GALLERY + `/:gallerySlug`}
                element={<GallerySingle />}
              />
              {/* <Route exact path="/404" element={<NotFound />} /> */}
              <Route exact path="/:slug/*" element={<Page />} />
              <Route path="/*" element={<Home />} />
              {/* <Route path="*" element={<NotFound />} /> */}
            </Routes>
          </Suspense>
          <CookieConsent />
        </BrowserRouter>
      </OpenCloseContactContext.Provider>
    </LoaderContext.Provider>
  );
}

export default App;
